function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Descriptions, Skeleton, Tabs, Modal, Drawer, message, Divider } from 'antd';
import { Container, Row, Col, Table } from "react-bootstrap";
import Common from "../components/includes/Common";
import 'bootstrap/dist/css/bootstrap.min.css';
import ValidationSheet from "../components/ValidationSheet";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { CheckCircleFill, XCircleFill, HourglassSplit, QuestionCircleFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TabPane = Tabs.TabPane;
var confirm = Modal.confirm;
var SearchRnc = function SearchRnc() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    customer = _useState4[0],
    setCustomer = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedCustomer = _useState6[0],
    setSelectedCustomer = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    customers = _useState8[0],
    setCustomers = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    dataUpdated = _useState0[0],
    setDataUpdated = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isValidationPending = _useState10[0],
    setIsValidationPending = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSearchDataLoading = _useState12[0],
    setIsSearchDataLoading = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isValidationDrawerOpen = _useState14[0],
    setIsValidationDrawerOpen = _useState14[1];
  var ref = useRef();
  var reprint = function reprint() {
    var content = document.getElementById("reprintid");
    var pri = document.getElementById("ifmcontentstoreprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };
  var showSheet = function showSheet(c) {
    setSelectedCustomer(c);
    setIsValidationDrawerOpen(true);
  };
  var handleValidation = function handleValidation(c) {
    setSelectedCustomer(c);
    //setIsValidationDrawerOpen(true);
    confirm({
      title: "Confirmez-vous la validation de " + c.firstname + ' ' + c.lastname + "?",
      cancelText: "Annuler",
      okText: "VALIDER",
      confirmLoading: isValidationPending,
      onOk: function onOk() {
        setIsValidationPending(true);
        axios.post(Common.baseApiUrl + "validatecandidate", {
          id: c.id,
          rnc: c.rnc,
          aid: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            message.success({
              content: response.data.message,
              delay: 4
            });
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {
          setIsValidationPending(false);
        });
      }
    });
  };
  var printR = function printR() {
    var printContents = document.getElementById("printable").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };
  var onFinish = function onFinish(values) {
    setIsSearchDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcustomerbyrnc/' + values.rnc).then(function (response) {
      setIsSearchDataLoading(false);
      if (response.data.status == 200) setCustomer(response.data.customer);
    })["catch"](function (error) {
      setIsSearchDataLoading(false);
    });
  };
  useEffect(function () {
    setIsSearchDataLoading(false);
    axios.get(Common.baseApiUrl + 'getvalidationqueue/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCustomers(response.data.customers);
        if (selectedCustomer != null) {
          setSelectedCustomer(response.data.customers.filter(function (c) {
            return c.id == selectedCustomer.id;
          })[0]);
        }
        if (customer != null) {
          setCustomer(response.data.customers.filter(function (c) {
            return c.id == selectedCustomer.id;
          })[0]);
        }
      } else {}
    })["catch"](function (error) {})["finally"](function () {
      setDataUpdated(false);
    });
    console.log(JSON.stringify(selectedCustomer));
  }, [dataUpdated]);
  var periodArray = [120000, 90000, 150000, 180000, 120000, 80000, 130000, 160000, 190000, 120000, 240000, 220000, 260000, 230000, 300000, 145000];
  useEffect(function () {
    setInterval(function () {
      setDataUpdated(true);
    }, periodArray[Math.floor(Math.random() * periodArray.length)]);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoreprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsx("div", {
      style: {
        textAlign: 'center'
      },
      id: "reprintid",
      children: customer != null && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: '70px'
          },
          children: /*#__PURE__*/_jsx("img", {
            src: "drawables/mvc.jpeg",
            style: {
              width: '100%'
            }
          })
        }), /*#__PURE__*/_jsxs("h2", {
          children: ["RNC : ", customer.rnc]
        }), /*#__PURE__*/_jsxs(Descriptions, {
          column: 1,
          children: [/*#__PURE__*/_jsx(Descriptions.Item, {
            label: "T\xE9l\xE9phone : ",
            children: customer.mobile
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "Nom :",
            children: customer.firstname + ' ' + customer.lastname
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "Montant : ",
            children: "200 000 GNF"
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "M. Paiement : ",
            children: customer.paymentmethod
          })]
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx("b", {
            children: "Adresse: Conakry, Kip\xE9, Prima center. Tel: 611 72 49 21"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {
            className: "pad white-bg",
            children: /*#__PURE__*/_jsxs(Tabs, {
              children: [/*#__PURE__*/_jsxs(TabPane, {
                tab: /*#__PURE__*/_jsx("b", {
                  children: "EN ATTENTE"
                }),
                children: [customers && /*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("th", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "RNC"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "Pr\xE9nom"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "T\xE9l\xE9phone"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "status"
                      }), /*#__PURE__*/_jsx("th", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: customers.filter(function (cu) {
                      return cu.optaresult_id != null && cu.status == 0;
                    }).map(function (c) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(c.created_at).toLocaleDateString('Fr', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric'
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.rnc
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.mobile
                        }), /*#__PURE__*/_jsxs("td", {
                          children: [c.status == 0 && /*#__PURE__*/_jsx(HourglassSplit, {
                            size: 30,
                            style: {
                              color: "#198794"
                            }
                          }), c.status == 1 && /*#__PURE__*/_jsx(CheckCircleFill, {
                            size: 30,
                            style: {
                              color: "#1AAF41"
                            }
                          }), c.status == 2 && /*#__PURE__*/_jsx(XCircleFill, {
                            size: 30,
                            style: {
                              color: "#AF351A"
                            }
                          })]
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              showSheet(c);
                            },
                            children: "Voir Fiche"
                          })
                        })]
                      }, 'q' + c.id.toString());
                    })
                  })]
                }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              }, '1'), /*#__PURE__*/_jsxs(TabPane, {
                tab: /*#__PURE__*/_jsx("b", {
                  children: "TRAITE"
                }),
                children: [customers && /*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("th", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "RNC"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "Pr\xE9nom"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "T\xE9l\xE9phone"
                      }), /*#__PURE__*/_jsx("th", {
                        children: "status"
                      }), /*#__PURE__*/_jsx("th", {})]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: customers.filter(function (cu) {
                      return cu.optaresult_id != null && cu.status != 0;
                    }).map(function (c) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: new Date(c.created_at).toLocaleDateString('Fr', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric'
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.rnc
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: c.mobile
                        }), /*#__PURE__*/_jsxs("td", {
                          children: [c.status == 0 && /*#__PURE__*/_jsx(HourglassSplit, {
                            size: 30,
                            style: {
                              color: "#198794"
                            }
                          }), c.status == 1 && /*#__PURE__*/_jsx(CheckCircleFill, {
                            size: 30,
                            style: {
                              color: "#1AAF41"
                            }
                          }), c.status == 2 && /*#__PURE__*/_jsx(XCircleFill, {
                            size: 30,
                            style: {
                              color: "#AF351A"
                            }
                          })]
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              showSheet(c);
                            },
                            children: "Voir Fiche"
                          })
                        })]
                      }, 'q' + c.id.toString());
                    })
                  })]
                }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              }, '2'), /*#__PURE__*/_jsxs(TabPane, {
                tab: /*#__PURE__*/_jsx("b", {
                  children: "CHERCHER"
                }),
                children: [/*#__PURE__*/_jsxs("div", {
                  className: "white-bg cool-radius",
                  children: [/*#__PURE__*/_jsx(Form, {
                    onFinish: onFinish,
                    layout: "vertical",
                    children: /*#__PURE__*/_jsx(Container, {
                      children: /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 7,
                          md: 7,
                          sm: 8,
                          xs: 8,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "rnc",
                            label: "Entrer le RNC",
                            rules: [{
                              required: true,
                              message: 'Veuillez entrer le RNC'
                            }],
                            children: /*#__PURE__*/_jsx(Input, {})
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: " ",
                            children: /*#__PURE__*/_jsx(Button, {
                              size: "large",
                              htmlType: "submit",
                              type: "primary",
                              children: "Chercher"
                            })
                          })
                        })]
                      })
                    })
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
                }), /*#__PURE__*/_jsxs("div", {
                  className: "cool-radius white-bg",
                  style: {
                    minHeight: '300px',
                    padding: '15px'
                  },
                  children: [(isSearchDataLoading || customer == null) && /*#__PURE__*/_jsx(Skeleton, {
                    active: isSearchDataLoading && customer == null
                  }), !isSearchDataLoading && customer != null && /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsx(Container, {
                      children: /*#__PURE__*/_jsx(Row, {
                        children: /*#__PURE__*/_jsxs(Col, {
                          children: [/*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            onClick: function onClick() {
                              handleValidation(customer);
                            },
                            children: /*#__PURE__*/_jsx("b", {
                              children: "VALIDER LE CANDIDAT"
                            })
                          }), /*#__PURE__*/_jsx(Divider, {})]
                        })
                      })
                    }), /*#__PURE__*/_jsx(ValidationSheet, {
                      ref: ref,
                      customer: customer
                    }), /*#__PURE__*/_jsx(Row, {
                      children: /*#__PURE__*/_jsx(Col, {
                        children: /*#__PURE__*/_jsx(ReactToPrint, {
                          content: function content() {
                            return ref.current;
                          },
                          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
                            children: function children(_ref) {
                              var handlePrint = _ref.handlePrint;
                              return /*#__PURE__*/_jsx(Button, {
                                size: "large",
                                type: "primary",
                                onClick: handlePrint,
                                children: "Imprimer"
                              });
                            }
                          })
                        })
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsx("iframe", {
                  id: "formprint",
                  style: {
                    height: '0px',
                    width: '0px',
                    position: 'absolute'
                  }
                })]
              }, '3')]
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      title: "FICHE DE VALIDATION",
      visible: isValidationDrawerOpen,
      onClose: function onClose() {
        setIsValidationDrawerOpen(false);
        setDataUpdated(true);
      },
      width: "95%",
      destroyOnClose: true,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              children: [/*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: function onClick() {
                  handleValidation(selectedCustomer);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "VALIDER LE CANDIDAT"
                })
              }), /*#__PURE__*/_jsx(Divider, {})]
            })
          })
        }), /*#__PURE__*/_jsx(ValidationSheet, {
          ref: ref,
          customer: selectedCustomer
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(ReactToPrint, {
              content: function content() {
                return ref.current;
              },
              children: /*#__PURE__*/_jsx(PrintContextConsumer, {
                children: function children(_ref2) {
                  var handlePrint = _ref2.handlePrint;
                  return /*#__PURE__*/_jsx(Button, {
                    size: "large",
                    type: "primary",
                    onClick: handlePrint,
                    children: "Imprimer"
                  });
                }
              })
            })
          })
        })]
      })
    })]
  });
};
export default SearchRnc;